import React, { useEffect, useState } from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import CustomerService from '../../services/CustomerService';

export default function CustomerAtAGlance({ customerId }) {
    const [info, setInfo] = useState(null);

    useEffect(() => {
        if (!customerId) return;
        CustomerService.getCustomerInfo(customerId).then(setInfo).catch(() => {});
    }, [customerId]);

    if (!info) return (
        <Typography variant="body2" sx={{ color: '#94a3b8' }}>—</Typography>
    );

    const { totalProjects, activeProjects, totalRevenue, maxProjectsPerCustomer, remainingProjects } = info;

    const pct = maxProjectsPerCustomer > 0
        ? Math.min(Math.round((totalProjects / maxProjectsPerCustomer) * 100), 100)
        : 0;

    const barColor = pct >= 100 ? '#ef4444' : pct >= 80 ? '#f59e0b' : '#427898';

    const statLabel = (text) => (
        <Typography sx={{ fontSize: 10, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1, mb: 0.4, lineHeight: 1 }}>
            {text}
        </Typography>
    );

    const statValue = (text) => (
        <Typography variant="body2" fontWeight={700} sx={{ color: '#1a2332' }}>
            {text}
        </Typography>
    );

    return (
        <Box>
            {/* Key stats — 2 columns */}
            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', mb: 2.5 }}>
                <Box sx={{ pr: 1.5, borderRight: '1px solid #f1f5f9' }}>
                    {statLabel('Revenue')}
                    {statValue(`CHF ${totalRevenue != null ? Number(totalRevenue).toLocaleString('de-CH', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) : '—'}`)}
                </Box>
                <Box sx={{ pl: 1.5 }}>
                    {statLabel('Active')}
                    {statValue(`${activeProjects ?? '—'} project${activeProjects !== 1 ? 's' : ''}`)}
                </Box>
            </Box>

            {/* Project quota bar */}
            <Box sx={{ pt: 2, borderTop: '1px solid #f1f5f9' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 0.75 }}>
                    {statLabel('Projects')}
                    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.4 }}>
                        <Typography variant="caption" fontWeight={700} sx={{ color: '#427898' }}>
                            {totalProjects}
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#94a3b8' }}>
                            / {maxProjectsPerCustomer}
                        </Typography>
                    </Box>
                </Box>

                <LinearProgress
                    variant="determinate"
                    value={pct}
                    sx={{
                        height: 5,
                        borderRadius: 3,
                        backgroundColor: '#e8edf2',
                        '& .MuiLinearProgress-bar': { backgroundColor: barColor, borderRadius: 3 },
                    }}
                />

                <Typography variant="caption" sx={{ color: remainingProjects === 0 ? '#ef4444' : '#64748b', mt: 0.75, display: 'block', fontWeight: remainingProjects === 0 ? 600 : 400 }}>
                    {remainingProjects > 0
                        ? `${remainingProjects} slot${remainingProjects !== 1 ? 's' : ''} remaining`
                        : 'Project limit reached'}
                </Typography>
            </Box>
        </Box>
    );
}
